import { render, staticRenderFns } from "./trans_phone.vue?vue&type=template&id=1baad5cf&scoped=true"
import script from "./trans_phone.vue?vue&type=script&lang=js"
export * from "./trans_phone.vue?vue&type=script&lang=js"
import style0 from "./trans_phone.vue?vue&type=style&index=0&id=1baad5cf&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baad5cf",
  null
  
)

export default component.exports